import { render, staticRenderFns } from "./approveRejectForm.vue?vue&type=template&id=c6337c5c"
import script from "./approveRejectForm.vue?vue&type=script&lang=js"
export * from "./approveRejectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports